import React, { useLayoutEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { RedirectAs404 } from "../utils/Utils";
import NCSCDA from "../pages/pre-built/user-manage/NCSCDA";
import NCSCDAEdit from "../pages/pre-built/user-manage/Edit/NCSCDAEdit";
import NCSCDAView from "../pages/pre-built/user-manage/NCSCDAView";
import UserDetailsRegular from "../pages/pre-built/user-manage/UserDetailsRegular";
import AdminDashboard from "../pages/pre-built/user-manage/AdminDashboard";
import AddUser from "../pages/pre-built/user-manage/AddUser";
import AddDetail from "../pages/pre-built/user-manage/AddDetail";
import ReportIntake from "../pages/pre-built/user-manage/Reports/ReportIntake";
import Jobsikers from "../pages/pre-built/user-manage/Reports/Jobsikers";
import Incumbancy from "../pages/pre-built/user-manage/Reports/Incumbancy";
import Trade from "../pages/pre-built/user-manage/Reports/Trade";
import Report1 from "../pages/pre-built/user-manage/Reports/Report1.";
import ReportNew from "../pages/NewReports/ReportNew";
import { ReportIntakeNew } from "../pages/NewReports/ReportIntake";
import { ReportEvaluation} from "../pages/NewReports/ReportEvolution";
import { ReportRehabilitation } from "../pages/NewReports/ReportRehabilitation";
import { ReportRehabilitationVH } from "../pages/NewReports/ReportRehabilitationVH";
import { ReportRehabilitationHH } from "../pages/NewReports/ReportRehabilitationHH";
import { ReportRehabilitationOH } from "../pages/NewReports/RehabilitationReportOH";
import { ReportRehabilitationCI } from "../pages/NewReports/RehabilitationReportCI";
import { ReportRehabilitationMR } from "../pages/NewReports/RehabilitationReportMR";
import { ReportRehabilitationMD } from "../pages/NewReports/RehabilitationReportMD";
import { ReportRehabilitationOthers } from "../pages/NewReports/RehabilitationReportOthers";
import { ReportJobsikers } from "../pages/NewReports/ReportJobSikers";
import { ReportTrade } from "../pages/NewReports/ReportTrade";
import { ReportIncumbancy } from "../pages/NewReports/ReportIncumbancy";

const Pages = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <Switch>
      {/*Dashboards*/}

      <Route
        exact
        path={`${process.env.PUBLIC_URL}/Dashboard`}
        component={UserDetailsRegular}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/Admin-Dashboard`}
        component={AdminDashboard}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/Add-User`}
        component={AddUser}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/Add-Detail`}
        component={AddDetail}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/NCSCDA`}
        component={NCSCDA}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/NCSCDA-View`}
        component={NCSCDAView}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/NCSCDA-Edit`}
        component={NCSCDAEdit}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/Report`}
        component={ReportNew}
      ></Route>
      {/*<Route exact path={`${process.env.PUBLIC_URL}/Report`} component={Report}></Route>*/}
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/reportnew`}
        component={ReportRehabilitationHH}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/Report1`}
        component={Report1}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/ReportIntakeold`}
        component={ReportIntake}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/ReportIntake`}
        component={ReportIntakeNew}
      ></Route> 
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/ReportEvaluation`}
        component={ReportEvaluation}
      ></Route>

        {/*New Report Link*/}

       <Route
        exact
        path={`${process.env.PUBLIC_URL}/rehabilitationnew`}
        component={ReportRehabilitation}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/rehabilitationnewVH`}
        component={ReportRehabilitationVH}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/rehabilitationnewHH`}
        component={ReportRehabilitationHH}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/rehabilitationnewOH`}
        component={ReportRehabilitationOH}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/rehabilitationnewCI`}
        component={ReportRehabilitationCI}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/rehabilitationnewMR`}
        component={ReportRehabilitationMR}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/rehabilitationnewMD`}
        component={ReportRehabilitationMD}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/rehabilitationnewOthers`}
        component={ReportRehabilitationOthers}
      ></Route>

      <Route
        exact
        path={`${process.env.PUBLIC_URL}/ReportRehabilitation`}
        component={ReportRehabilitation}
      ></Route>
       <Route
        exact
        path={`${process.env.PUBLIC_URL}/ReportJobsikers`}
        component={ReportJobsikers}
      ></Route> 
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/ReportTrade`}
        component={ReportTrade}
      ></Route>
       <Route
        exact
        path={`${process.env.PUBLIC_URL}/ReportIncumbancy`}
        component={ReportIncumbancy}
      ></Route>

        {/*Report new END*/}

      <Route
        exact
        path={`${process.env.PUBLIC_URL}/Jobsikers`}
        component={Jobsikers}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/Incumbancy`}
        component={Incumbancy}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/RehabilitationVh`}
        component={ReportRehabilitationVH}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/RehabilitationHH`}
        component={ReportRehabilitationHH}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/RehabilitatiOH`}
        component={ReportRehabilitationOH}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/RehabilitationCl`}
        component={ReportRehabilitationCI}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/RehabilitationMR`}
        component={ReportRehabilitationMR}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/RehabilitationMD`}
        component={ReportRehabilitationMD}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/RehabilitationOthers`}
        component={ReportRehabilitationOthers}
      ></Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/Trade`}
        component={Trade}
      ></Route>

      <Route component={RedirectAs404}></Route>
    </Switch>
  );
};
export default Pages;
